import React from "react";
import CustomerConsignmentStatusType from "../common/enum/CustomerConsignmentStatusType";
import {formatDateTime} from "../common/util/FormatUtil";

interface ConsignmentStatusBadgeProps {
    consignment: CustomerAPIConsignmentResponse
}

const ConsignmentStatusBadge = (props: ConsignmentStatusBadgeProps) => {

    const formatTimestamp = (input: string) => {
        if (!input) {
            return "";
        }
        return formatDateTime(new Date(input));
    }

    const { delivery } = props.consignment;
    const status = CustomerConsignmentStatusType.valueOf(props.consignment.status)!;

    return (
        <>
            <span className="badge p-2" style={{
                backgroundColor: status.colour,
                color: 'white',
                fontWeight: '500'
            }}>{status.description}</span>
                {status === CustomerConsignmentStatusType.COMPLETED &&
                    <span style={{fontSize: '80%'}}><br />{formatTimestamp(props.consignment.completedAt)}</span>
                }
                {status === CustomerConsignmentStatusType.ARRIVED && delivery.arrivedAt &&
                    <span style={{fontSize: '80%'}}><br />{formatTimestamp(delivery.arrivedAt)}</span>
                }
        </>
    )

}

export default ConsignmentStatusBadge;
